import realpressAgentProperty from './agent-detail/agent-property-2';
import realpressContactForm from './agent-detail/contact-form';
import { default as ContactFormWidget } from './widgets/contact-form';
import realpressAgentSearch from './widgets/agent-search';

document.addEventListener( 'DOMContentLoaded', ( event ) => {
	realpressAgentProperty();
	realpressContactForm();
	realpressAgentSearch();
	ContactFormWidget();
} );
